<template>
  <div class="page">
    <template v-if="!noRights">
      <div style="display:none" v-title>医生中心</div>
      <div class="register-favor" :style="avatar"></div>
      <div class="wsp-user-btn" @click="toUserInfo">个人资料</div>
      <router-link :to="{ name: 'Forget', query: { comcode: comcode, openid: openid }}"><div class="wsp-forget-btn">忘记密码</div></router-link>
      <div class="pr"><i class="wsp-logo"></i></div>
    </template>
    <template v-if="noRights">
      <div class="no-rights">参数错误！</div>
    </template>
  </div>
</template>

<script>
import md5 from 'js-md5'
export default {
  name: 'UserCenter',
  data () {
    return {
      noRights: false,
      avatarUrl: '',
      comcode: '',
      openid: ''
    }
  },
  computed: {
    avatar: function () {
      return this.avatarUrl ? 'background-image:url("' + this.avatarUrl + '")' : ''
    }
  },
  created () {
    let secret = 'tL92QZVP5WS1b7X8'
    let appkey = 'b9916545aR3c35E71fYFedq3b8i6ea9f'
    let formet = 'json'
    let serial = Date.parse(new Date()) / 1000
    let ver = '1.0'
    let doctorid = this.$route.query.doctorid
    this.comcode = this.$route.query.comcode
    this.openid = this.$route.query.openid

    let sign1 = md5(secret + appkey + doctorid + formet + serial + ver)
    let params1 = {
      serial: serial,
      ver: ver,
      formet: formet,
      secret: secret,
      appkey: appkey,
      sign: sign1,
      doctorid: doctorid
    }
    // 医生信息
    this.$axios.get('/Index/Doctor/Info', { params: params1 }).then((response) => {
      if (response.data.code !== 1000) {
        this.noRights = true
      } else {
        this.avatarUrl = response.data.data[0].avatar
      }
    }).catch(function () {})
  },
  methods: {
    // 用户信息
    toUserInfo () {
      this.$router.push({
        path: '/Doctor/UserInfo',
        query: {
          comcode: this.$route.query.comcode,
          doctorid: this.$route.query.doctorid
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.page
  width 720px
  margin 0 auto
  background-color #f5f5f5
.register-favor
  margin 124px auto 96px auto
  width 232px
  height 232px
  background-size 232px auto
  background-position center center
  font-size: 24px; /*px*/
  background-image url('../assets/images/no-user.png')
  background-repeat no-repeat
  background-position center center
.wsp-user-btn
  margin 0 auto
  width 513px
  height 88px
  line-height 88px
  text-align center
  font-size: 35px; /*px*/
  letter-spacing 7px
  color #ffffff
  background-image url('../assets/images/l-btn.png')
  background-size 513px 86px
  background-repeat no-repeat
  font-weight 300
  margin-bottom 38px
.wsp-forget-btn
  margin 0 auto
  width 513px
  height 88px
  line-height 88px
  text-align center
  font-size: 35px; /*px*/
  letter-spacing 7px
  color #0ab5c0
  border-radius 5px
  background-color #ffffff
  background-size 513px 86px
  background-repeat no-repeat
  font-weight 300
</style>



// WEBPACK FOOTER //
// src/pages/UserCenter.vue